<div edsPadding edsPaddingTop="xs">
  <eds-section-header
    [title]="title"
    size="h6"
    [level]="3"
    [caveatPlacement]="placement"
    [tooltip]="tooltip"
  ></eds-section-header>
</div>
